import {INamedRoute, IRouter} from '../../@interfaces/services/Router';
import {Constructable} from '../../@types/instantable';

export default abstract class AbstractRouter<RouteInterface extends INamedRoute> implements IRouter<RouteInterface> {
    protected routesMap: Record<string, number> = {};
    protected routes: RouteInterface[] = [];
    protected abstract routeConstructor: Constructable<RouteInterface>;

    getRoutes(): RouteInterface[] {
        return this.routes;
    }

    getRouteByName(name: string): RouteInterface | null {
        if (name in this.routesMap && this.routes[this.routesMap[name]]) {
            return this.routes[this.routesMap[name]];
        }

        for (let i = 0; i < this.routes.length; i++) {
            const route = this.routes[i];
            if (route.getName() === name) {
                return route;
            }
        }

        return null;
    }

    abstract getRouteByUri(name: string): RouteInterface | null;

    addRoute(route: RouteInterface): IRouter<RouteInterface> {
        const index = this.routes.push(route) - 1;

        const routeName = route.getName();
        if (routeName) {
            this.routesMap[routeName] = index;
        }

        return this;
    }

    createRoute(path: string): RouteInterface {
        return new this.routeConstructor({path});
    }

    getFirstExistsRouteName(names: string[]): string | null {
        for (const name of names) {
            if (this.getRouteByName(name)) {
                return name;
            }
        }

        return null;
    }
}
